/* 订单-模块API */

import { GET, POST, download, uploading, POSTFormData } from '@/request/http'

// 分页查询订单
export const getOrderTable = p => POST('/order/page', p)
// 查询设备订单
export const getEquipmentworkTable = p => POST('/order/equipmentwork/page', p)



// WEBPACK FOOTER //
// ./src/api/modules/order.js